import { Outlet, useLocation, useNavigate } from "react-router-dom";
import NotificationStripNav from "../NotificationStripNav/NotificationStripNav";
import Utils from "../Utils/Utils";
import { useEffect, useState } from "react";
import { StoryblokComponent } from "@storyblok/react";
import { NotificationProvider } from "../Notification/NotificationProvider";
import { themeService } from "../NotificationStripNav/ThemeService";
import { parametersService } from "../NotificationStripNav/ParametersService";
import { Theme } from "../Models/CustomSiteConfigModel";
import { Parameters } from "../Models/CustomSiteConfigModel";

const Layout = () => {
  const [customSiteConfig, setCustomSiteConfig] = useState<any>({});
  const navigate = useNavigate();
  const location = useLocation();
  const isErrorPage =
    location.pathname === "/404" || location.pathname === "/500";

  useEffect(() => {
    const siteConfigSession = sessionStorage.getItem("site_config");
    const siteConfig = siteConfigSession ? JSON.parse(siteConfigSession) : null;
    if (siteConfig && siteConfig.content) {
      setCustomSiteConfig(siteConfig);
      themeService.setTheme(siteConfig?.content as Theme);
      parametersService.setParameters(siteConfig?.content as Parameters);
    } else {
      Utils.getCachedOrStoryblokSiteConfig()
        .then((response: any) => {
          const { story, rels } = response;
          const mappedStory = Utils.mapResolvedRelations(story, rels);
          sessionStorage.setItem("site_config", JSON.stringify(mappedStory));
          setCustomSiteConfig(mappedStory);
          themeService.setTheme(mappedStory?.content as Theme);
          parametersService.setParameters(mappedStory?.content as Parameters);
        })
        .catch((error) => {
          if (error.status === 404) {
            navigate("/404");
          } else if (error.status === 500) {
            navigate("/500");
          }
        });
    }
  }, [navigate]);

  return (
    <>
      <NotificationProvider>
        {!isErrorPage && (
          <NotificationStripNav
            customSiteConfig={customSiteConfig}
          ></NotificationStripNav>
        )}

        <main>
          <Outlet />
        </main>
        {!isErrorPage && (
          <footer>
            {customSiteConfig?.content?.footer &&
            customSiteConfig?.content?.footer?.length > 0
              ? customSiteConfig.content.footer.map((blokk: any) => (
                  <StoryblokComponent blok={blokk} key={blokk._uid} />
                ))
              : null}
          </footer>
        )}
      </NotificationProvider>
    </>
  );
};

export default Layout;
